import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('usuario', 'transferencia');

const transferenciaPosseActions = {
  listarTemporarios: { method: 'GET', url: `${basePath}?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}` },
  listarHistorico: { method: 'GET', url: `${basePath}/historico?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}` },
  listarDivisoes: { method: 'GET', url: `${basePath}/divisao?nome={nome}&{&idNotIn*}` },
  listarFuncionarios: { method: 'GET', url: `${basePath}/funcionario?nome={nome}&{&idNotIn*}` },
  remover: { method: 'PUT', url: `${basePath}` },
  transferir: { method: 'POST', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, transferenciaPosseActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/controlador-trade/transferencia-posse.js